<template>
  <SfBreadcrumbs :items="breadcrumbItems" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import SfBreadcrumbs from '@app/shared/vue/components/sf-breadcrumbs/sf-breadcrumbs.vue'
import type { BreadcrumbItem } from '@app/shared/vue/components/sf-breadcrumbs/types'
import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

type Props = {
  staticItems: BreadcrumbItem[]
}

const props = defineProps<Props>()

const { currentReviewItem } = storeToRefs(useWorfklowReviewItems())

const breadcrumbItems = computed<BreadcrumbItem[]>(() => {
  if (!currentReviewItem.value) return props.staticItems
  return [...props.staticItems, { label: currentReviewItem.value.itemName }]
})
</script>
